{
  "pt": {
    "dashboard": {
      "greetings": {
        "afternoon": "Boa tarde {first_name}",
        "evening": "Boa noite {first_name}",
        "morning": "Bom dia {first_name}",
        "night": "Boa noite {first_name}"
      },
      "milestones": {
        "action_title_decision": "Escolha {name}",
        "action_title_survey": "Preencha {name}",
        "action_title_ticket": "Nova mensagem sobre {name}",
        "count_open": "{count} em aberto",
        "journey_hide": "Ocultar o percurso do projeto",
        "journey_show": "Ver o percurso do projeto",
        "journey_step_active": "Em curso",
        "journey_step_completed": "Concluída",
        "journey_step_planned": "Planeada",
        "other_empty_subtitle": "{client} avisa-o assim que houver algo à sua espera.",
        "other_empty_title": "Está tudo em dia",
        "other_promoted_title": "Precisa da sua atenção",
        "other_title": "Outras ações",
        "stage_done_subtitle": "{client} avisa-o quando chegar o próximo passo.",
        "stage_done_title": "Está tudo feito nesta fase",
        "stage_empty": "De momento não há nada a fazer nesta fase.",
        "stage_eyebrow": "Fase atual",
        "stage_final_subtitle": "Todos os passos do seu projeto estão concluídos. Mantemo-lo a par se algo mudar.",
        "stage_final_title": "Está tudo concluído",
        "stage_last": "Esta é a última fase",
        "stage_next": "A seguir: {phase}",
        "stage_position": "Fase {current} de {total}",
        "stage_todo_title": "Para concluir esta fase"
      },
      "titles": {
        "activityFeed": "Feed de atividades",
        "assignedTasks": "As minhas tarefas",
        "newsFeed": "Feed de notícias",
        "ongoingTickets": "Em curso",
        "openTickets": "Aberto",
        "progress": "Progresso",
        "tickets": "Conversas",
        "totalTickets": "Todas as conversas",
        "unreadTickets": "Não lido",
        "yourAssignedTickets": "Atribuídas a si"
      }
    }
  }
}
